<!-- ContactsIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Book/Address book outline -->
    <path 
      d="M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Spine tabs -->
    <path 
      d="M4 6H2V10H4" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M4 14H2V18H4" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Person icon inside -->
    <circle 
      cx="12" 
      cy="9" 
      r="2.5" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M16 17C16 14.7909 14.2091 13 12 13C9.79086 13 8 14.7909 8 17" 
      stroke="#333333" 
      stroke-width="1.5" 
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>